(function() {
  const THRESHOLD_ATTR = 'data-threshold';
  const INNER_HTML = `
    <div class="crosstac-shipping-teaser__content">
      <div class="crosstac-shipping-teaser__message"></div>
      <div class="crosstac-shipping-teaser__track">
        <div class="crosstac-shipping-teaser__bar"></div>
      </div>
      <div class="crosstac-shipping-teaser__qualified">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span>You've unlocked free shipping!</span>
      </div>
    </div>`;

  class CrosstacShippingTeaser extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('.crosstac-shipping-teaser__content')) {
        this.innerHTML = INNER_HTML;
      }
      this.updateProgress();
    }

    async updateProgress() {
      const messageEl = this.querySelector('.crosstac-shipping-teaser__message');
      const progressBar = this.querySelector('.crosstac-shipping-teaser__bar');
      if (!messageEl || !progressBar) return;

      const threshold = parseInt(this.getAttribute(THRESHOLD_ATTR)) || 20000;

      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const cartTotal = cart.total_price;
        const remaining = threshold - cartTotal;
        const percentage = Math.min((cartTotal / threshold) * 100, 100);

        if (remaining <= 0) {
          this.dataset.qualified = 'true';
          progressBar.style.width = '100%';
        } else {
          this.dataset.qualified = 'false';
          progressBar.style.width = percentage + '%';
          const dollars = (remaining / 100).toFixed(2);
          messageEl.innerHTML = 'Add <strong>$' + dollars + '</strong> more for free shipping';
        }
      } catch (e) {
        console.error('Shipping teaser error:', e);
      }
    }
  }

  if (!customElements.get('crosstac-shipping-teaser')) {
    customElements.define('crosstac-shipping-teaser', CrosstacShippingTeaser);
  }

  // Stored threshold from the Liquid-rendered element on page load
  let cachedThreshold = '20000';

  function getThreshold() {
    const el = document.querySelector('crosstac-shipping-teaser');
    if (el && el.dataset.threshold) cachedThreshold = el.dataset.threshold;
    return cachedThreshold;
  }

  function ensureTeaser() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    const summary = drawer.querySelector('.cart-drawer__summary');
    if (!summary) return;

    let teaser = summary.querySelector('crosstac-shipping-teaser');
    if (!teaser) {
      teaser = document.createElement('crosstac-shipping-teaser');
      teaser.className = 'crosstac-shipping-teaser';
      teaser.dataset.qualified = 'false';
      teaser.dataset.threshold = getThreshold();
      summary.insertBefore(teaser, summary.firstChild);
    } else {
      // Teaser exists but may need a data refresh after morph
      teaser.updateProgress();
    }
  }

  function watchCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    // 1. MutationObserver — catches full re-renders (childList changes)
    let injecting = false;
    const observer = new MutationObserver(() => {
      if (injecting) return;
      injecting = true;
      ensureTeaser();
      requestAnimationFrame(() => { injecting = false; });
    });
    observer.observe(drawer, { childList: true, subtree: true });
    ensureTeaser();

    // Refresh after the theme's cart update has completed.
    document.addEventListener('shopify:cart:lines-update', (event) => {
      const refresh = () => {
        requestAnimationFrame(() => ensureTeaser());
      };

      if (event.promise?.then) {
        event.promise.then(refresh).catch(() => {});
      } else {
        refresh();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartDrawer);
  } else {
    watchCartDrawer();
  }
})();

